import React, { useState } from 'react'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const MediaGallery = ({ images, videos }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [openedImage, setOpenedImage] = useState('')
    const smallScreen = window.innerWidth < 600 

    const handleOpenImage = (image) =>{
        setOpenedImage(image.src)
        setIsOpen(true)
    }

    const handleCloseImage = () =>{
        setIsOpen(false)
        setOpenedImage('')
    }
  return (
    <>
    <div style={{ display: 'flex', height: smallScreen ? 200 : 400, marginTop: 10, padding: 7, overflowX: 'auto'}}>
        {
            videos?.length > 0 && videos.map((video)=>{
                return(
                    // <div style={{ height: '96%',display: 'flex', alignItems: 'center', padding: 0, marginRight: 10, borderRadius: 5 }}>
                    <div>
                        <iframe width={ smallScreen ? '320px' : '630px' } height={smallScreen ? "94%" : "92%"} frameborder={0} style={{ borderRadius: 5, marginRight: 10 }}
                            src={video.src}>
                        </iframe>
                        </div>
                    
                )
            })
        }
        {
            images?.length > 0 && images.map((image)=>{
                return(
                    // <div style={{ height: '96%',display: 'flex', alignItems: 'center', padding: 0, marginRight: 10, borderRadius: 5 }}>
                       < >
                        <img  height={smallScreen ? "94%" : "92%"} frameborder={0} style={{ borderRadius: 5, marginRight: 10, width:'100%' }} src={image.src} onClick={()=> handleOpenImage(image)}/>
                        </>
                   
                )
            })
        }
    </div>
    { isOpen &&
        <div>
            <Lightbox
                imageCrossOrigin={"anonymous"}
                onCloseRequest={handleCloseImage}
                mainSrc={openedImage}
                enableZoom={true}
                clickOutsideToClose={true}
            />
        </div>
    }
    </>
  )
}

export default MediaGallery